import React, { FC } from 'react';
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
const P = Schema.attributes;

const Projekterfolge: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Projekterfolge und Ausblick" description={PLATZHALTER_TEXT} />
			<CreateForm
				formStruc={formStrucProjekterfolge}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default Projekterfolge;

export const formStrucProjekterfolge = [
	{
		fields: [P.Projekterfolge_Und_Ausblick_Beschreibung],
		userProps: { columnToDivide: 1 },
	},
];
